import type { ReactNode } from 'react';
import { createApi, createDomain } from 'effector';

const domain = createDomain('noti');

enum NotiType {
  success = 'success',
  warning = 'warning',
  error = 'error',
}
type Noti = { id: string; type: NotiType; message: ReactNode };

export const $noti = domain.store<Noti[]>([]);
export const $notiApi = createApi($noti, {
  add: (store, payload: Noti) => [...store, payload],
  remove: (store, id: Noti['id']) => store.filter((x) => x.id !== id),
  clear: () => [],
});
